import axios from 'axios'
import {errorHelper, messageHelper} from '../helper.js'
import { SEARCH_MODERATOR_REQUEST_URL } from '../../../vars'

/**
 * @namespace ModeratorSearch
 */
export default {
    state: {
        searchResultModeratorRequest: null
    },
    mutations: {
        UPDATE_RESULT_SEARCH_MODERATOR_REQUEST(state, data) {
            state.searchResultModeratorRequest = data
        }
    },
    actions: {
        /**
         * Получает данные и записывает резуьтат поиска
         * @param {Object} ctx 
         * @param {String} data Строка поиска заявки
         * @throws Ошибка зпроса данных
         * 
         * @memberof ModeratorSearch
         */
        async GET_SEARCH_MODERATOR_REQUEST(ctx, data) {
            try {
                const res = await axios.get(SEARCH_MODERATOR_REQUEST_URL + `?text=${data}`, {
                    headers: {
                        Authorization: `Token ${localStorage.token}`
                    }
                });
                
                await ctx.commit('UPDATE_RESULT_SEARCH_MODERATOR_REQUEST', res.data)
                // console.log('eee', res)
            } catch(e) {
                errorHelper(e)
                messageHelper('', 'error', 6000, e)
                throw e
            }
        }
    },
    getters: {
       GETTERS_RESULT_SEARCH_MODERATOR_REQUEST(state) {
           return state.searchResultModeratorRequest
       }
    }
}